import React from 'react'

export default function AboutV2Two() {
    return (
        <section className="cs_gray_bg_2 position-relative overflow-hidden">
            <div className="cs_height_161 cs_height_lg_80"></div>
            <div className="container">
                <div className="cs_card cs_style_1 cs_type_1">
                    <div className="row cs_gap_y_50 position-relative z-1">
                        <div className="col-lg-6 order-lg-2">
                            <div className="cs_card_thumbnail position-relative">
                                <img src="/assets/img/about-img-2.png" alt="Uygulama Avantajları" />
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1">
                            <div className="cs_section_heading cs_style_1 cs_mb_19">
                                <div className="cs_section_subtitle cs_fs_18 cs_heading_color cs_mb_22">
                                    <img src="/assets/img/icons/star-1.svg" alt="Star" />
                                    <span>Uygulama Avantajları</span>
                                    <img src="/assets/img/icons/star-1.svg" alt="Star" />
                                </div>
                                <h2 className="cs_section_title cs_fs_48 cs_semibold mb-0 wow fadeInUp">
                                    Neden HatimTakip'i seçmelisiniz?
                                </h2>
                            </div>
                            <p className="cs_card_desc cs_mb_32">
                                Modern arayüzü ve kullanıcı dostu özellikleriyle hatim okuma deneyiminizi bir üst seviyeye taşıyın. 
                                İster bireysel ister grup halinde, kolayca takip edin.
                            </p>
                            <ul className="cs_list cs_style_1 cs_mp_0">
                                <li>
                                    <img src="/assets/img/icons/checkbox.svg" alt="Check" />
                                    <h3 className="cs_fs_18 cs_normal mb-0">Kolay özelleştirme</h3>
                                </li>
                                <li>
                                    <img src="/assets/img/icons/checkbox.svg" alt="Check" />
                                    <h3 className="cs_fs_18 cs_normal mb-0">Tamamen responsive tasarım</h3>
                                </li>
                                <li>
                                    <img src="/assets/img/icons/checkbox.svg" alt="Check" />
                                    <h3 className="cs_fs_18 cs_normal mb-0">Sürekli güncellenen özellikler</h3>
                                </li>
                                <li>
                                    <img src="/assets/img/icons/checkbox.svg" alt="Check" />
                                    <h3 className="cs_fs_18 cs_normal mb-0">7/24 destek</h3>
                                </li>
                            </ul>
                            <a href="https://expo.dev/artifacts/eas/2GRj8TuCDbUNLWsuRehcP6.apk" 
                               target="_blank" 
                               rel="noopener noreferrer"
                               className="cs_btn cs_style_1 cs_bg_1 cs_fs_14 cs_white_color cs_bold text-uppercase"
                               aria-label="Uygulamayı İndir">
                                <span>Uygulamayı İndir</span>
                                <span className="cs_btn_icon"><i className="fa-solid fa-arrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="cs_star_shape_2 position-absolute">
                    <img src="/assets/img/star-shape.svg" alt="Star" />
                </div>
                <div className="cs_star_shape_3 position-absolute">
                    <img src="/assets/img/star-shape.svg" alt="Star" />
                </div>
                <div className="cs_vector_shape_2 position-absolute">
                    <img src="/assets/img/vector.svg" alt="Vector" />
                </div>
                <div className="cs_elipse_2 cs_radius_100 position-absolute"></div>
                <div className="cs_elipse_3 cs_radius_100 position-absolute"></div>
                <div className="cs_elipse_4 cs_radius_100 position-absolute"></div>
            </div>
            <div className="cs_height_133 cs_height_lg_80"></div>
        </section>
    );
}


